import { defineComponent, ref } from '@vue/composition-api';
import Modal from 'src/components/project/analysis/results/Modal.vue';
import { BfButton } from 'components/Butterfly';
const ThemeNameModal = defineComponent({
    components: {
        BfButton,
        Modal,
    },
    props: {
        title: { type: String, required: true },
        body: { type: String, required: false, default: '' },
    },
    setup() {
        const visible = ref(false);
        const resolve = ref(null);
        // To be used via a ref in the parent component
        // e.g const res = await refs.confirmModal.value.confirm()
        const confirm = () => {
            return new Promise((res) => {
                resolve.value = res;
                visible.value = true;
            });
        };
        const submit = (val) => {
            visible.value = false;
            resolve.value?.(val);
        };
        return {
            visible,
            confirm,
            submit,
        };
    },
});
export default ThemeNameModal;
